function executeJS(code) {
  return eval(code);
}
/*jshint ignore:line*/
// Must be all in first line for debug line number